
import "./PageLoader.css";

function PageLoader() {
    return (

        <>

        <div className="page-loader">
            <div className="spinner"></div>
        </div>

        </>
    );
}

export default PageLoader;
